module.exports = __webpack_public_path__ + "static/media/Timer_watch.b3d037cd.svg";